export default __webpack_public_path__ + "static/media/background_only.f827fe58.png";